import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import "./profile.scss";
import { useAppSelector } from "../../../hooks/useAppSelector";
import moment from "moment";
import { getSubAdminDetail, getUserDetail } from "../services/action";
import { UseAppDispatch } from "../../../hooks/useAppDispatch";
import BreadCrumb from "../../../components/form-controls/breadCrumb";
import { USER } from "../../../constants/routes/routes-path";
export default function UserDetail() {
  let { id } = useParams();
  const dispatch = UseAppDispatch();
  const { detail } = useAppSelector((state) => state.adminDetail);
  const [userDetail, setUserDetail] = useState<any>({});

  useEffect(() => {
    if (detail) {
      setUserDetail(detail);
    }
  }, [detail]);

  const getUserData = () => {
    dispatch(getUserDetail(id));
  };

  useEffect(() => {
    getUserData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Box className="detail-wrapper" sx={{ width: "100%" }}>
        <div className="detail-container">
          <BreadCrumb
            showMultipleLink={true}
            mainLink={USER.fullUrl}
            mainLabel={"User Management"}
            secondaryLabel={"User Details"}
          />
        </div>

        <Box
          className={"profile-detail"}
          sx={{
            boxShadow: "none",
            padding: 5,
            borderRadius: 2,
            background: "#ffffff",
          }}
        >
          <div className="sub-title">User Deatils</div>
          <Divider className="role-divider" sx={{ margin: "20px 0px" }} />
          <Grid container spacing={4}>
            <Grid xs={3} sm={3} item>
              <Avatar
                alt="Avatar"
                src={userDetail?.avatar || ""}
                className=""
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  backgroundColor: "#199ab0",
                  color: "#ffffff",
                }}
              />
            </Grid>

            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">User ID</Typography>
              <p>{userDetail?.id}</p>
            </Grid>

            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Name</Typography>
              <p>
                <span>{userDetail?.first}</span>
                <span> {userDetail?.last}</span>
              </p>
            </Grid>

            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Phone Number</Typography>
              <p>
                {userDetail?.phoneNumber
                  ? `${userDetail?.countryCode} ${" "}${
                      userDetail?.phoneNumber
                    }`
                  : "N/A"}
              </p>
            </Grid>
            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Email ID</Typography>
              <p>{userDetail?.email}</p>
            </Grid>

            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Created On</Typography>
              <p>{moment(new Date(userDetail?.createdAt)).format("LL")}</p>
            </Grid>

            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Last login</Typography>
              <p>
                {userDetail?.updatedAt
                  ? moment(new Date(userDetail?.updatedAt)).format("LL")
                  : "N/A"}
              </p>
            </Grid>


            <Grid xs={3} sm={3} item>
              <Typography className="detail-title">Status</Typography>
              <p>{userDetail?.isActive ? "Activated" : "Deactivated"}</p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
